import React, { FC, useEffect, useRef } from "react";

import { Button, ButtonVariant, Dialog, Theme } from "@in/component-library";
import { useLayout } from "../../hooks/use-layout";

interface VerifyEmailSucceededProps {
  displayConfirmationModal: boolean;
  onClose: () => void;
}

const VerifyEmailSucceeded: FC<VerifyEmailSucceededProps> = ({
  displayConfirmationModal,
  onClose,
}) => {
  const { translations } = useLayout();

  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (displayConfirmationModal) {
      dialogRef?.current?.showModal();
    } else {
      dialogRef?.current?.close();
    }
  }, [displayConfirmationModal]);

  return (
    <Dialog
      className="email__modal"
      title={translations.confirmationHeader}
      onClose={onClose}
    >
      <p className="email__confirmation">
        {translations.verifyEmailVerifiedText}
      </p>

      <div aria-live="polite" className="email__button">
        <Button
          type="submit"
          variant={ButtonVariant.Solid}
          theme={Theme.Neutral}
          onClick={onClose}
        >
          {translations.verifyEmailCloseModal}
        </Button>
      </div>
    </Dialog>
  );
};

export default VerifyEmailSucceeded;
